import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import { RuleEditorModalComponent } from '../rule-editor-modal/rule-editor-modal.component';

import { IRuleParentInfo } from '@models/measures.model';

@Component({
  selector: 'app-rules',
  imports: [MatButtonModule, MatDialogModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './rules.component.html',
  styleUrl: './rules.component.css'
})

export class RulesComponent {
  
	@Input() criteriaId: number = 0;
	@Input() componentId: number = 0;
	@Input() ruleGroupId: number = 0;

  readonly dialog = inject(MatDialog);

  openDialog() {    
    let parentRuleInfo: IRuleParentInfo ={
      criteriaId: this.criteriaId,
      componentId: this.componentId,
      ruleGroupId: this.ruleGroupId
    }

    const dialogRef = this.dialog.open(RuleEditorModalComponent,{
      data: { parentInfo: parentRuleInfo }
    });
  }
}
